import { useNavigate } from "react-router-dom";
import CalendarStyle from './CalendarStyle'
import { Box, Grid, ToggleButton, ToggleButtonGroup, Typography } from "@mui/material";
import CalendarComponent from "../../components/calendarComponent/CalendarComponent";
import ButtonComponent from "../../components/button/ButtonComponent";
import { useEffect, useState } from "react";
import { useTranslation } from "react-i18next";
import i18n from "../../translation/translations";

const Calendar = () => {
  const { t } = useTranslation();
  const currentLanguage = localStorage.getItem("language")

  const [language, setLanguage] = useState(currentLanguage || "english");
  const navigateTo = useNavigate();

  const navigateAddEvent = () => {
    navigateTo("/add-event");
  };

  const handleChange = (
    _event: React.MouseEvent<HTMLElement>,
    newLanguage: string,
  ) => {
    setLanguage(newLanguage);
    localStorage.setItem("language", newLanguage)
  };

  useEffect(() => {
    if (currentLanguage === "spanish") {
      i18n.changeLanguage("sp");
    } else {
      i18n.changeLanguage("en");
    }
  }, [language, currentLanguage])

  return (
    <Box sx={{ ...CalendarStyle.mainBoxStyle }}>
      <Grid container>
        <Box sx={{ ...CalendarStyle.headerBoxStyle }}>
          <Grid >
            <Typography {...CalendarStyle.mainTitleTypo}>
              {t("homePage.calendar")}
              <Typography {...CalendarStyle.subTitleTypo} mt={1}>
                {t("homePage.calendarSubTitle")}
              </Typography>
            </Typography>
          </Grid>
          <Grid >
            <ToggleButtonGroup
              color="primary"
              value={language}
              exclusive
              onChange={handleChange}
              aria-label="Platform"
            >
              <ToggleButton value="english">English</ToggleButton>
              <ToggleButton value="spanish">Spanish</ToggleButton>
            </ToggleButtonGroup>
          </Grid>
          <Grid >
            <ButtonComponent
              text={t("homePage.addEvent")}
              sx={{
                ...CalendarStyle.mainBtnSx,
              }}
              onClick={() => navigateAddEvent()}
            />
          </Grid>
        </Box>

        <Grid item xs={12}>
          <Box mt={2}>
            <CalendarComponent />
          </Box>
        </Grid>
      </Grid>
    </Box>
  );
};

export default Calendar;
